import { render, staticRenderFns } from "./cn3020.vue?vue&type=template&id=5fe5c1b4&scoped=true&"
import script from "./cn3020.vue?vue&type=script&lang=js&"
export * from "./cn3020.vue?vue&type=script&lang=js&"
import style0 from "./cn3020.vue?vue&type=style&index=0&id=5fe5c1b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe5c1b4",
  null
  
)

export default component.exports